import createDocumentSlice from "./createDocumentSlice";
import { config } from "../../utils/apiUrl";

/*
|--------------------------------------------------------------------------
| QUOTATION MODULE
|--------------------------------------------------------------------------
*/

const quotationModule =
  createDocumentSlice({
    sliceName:
      "quotation",

    stateKey:
      "quotation",

    documentName:
      "Quotation",

    documentType:
      "QUOTATION",

    documentKey:
      "quotation",

    documentKeys: [
      "sourceQuotation",
    ],

    listKey:
      "quotations",

    urls: {
      list:
        config.getQuotations,

      summary:
        config.getQuotationSummary,

      createData:
        config.getQuotationCreateData,

      dropdowns:
        config.getQuotationDropdowns,

      getById:
        config.getQuotationById,

      create:
        config.createQuotation,

      update:
        config.updateQuotation,

      confirm:
        config.confirmQuotation,

      cancel:
        config.cancelQuotation,

      duplicate:
        config.duplicateQuotation,

      convert:
        config.convertQuotation,

      delete:
        config.deleteQuotation,

      history:
        config.getQuotationHistory,
    },

    initialFilters: {
      paymentStatus:
        "",

      fulfillmentStatus:
        "",
    },

    initialDropdowns: {
      documentStatuses: [],
      conversionStatuses: [],
      conversionTargets: [],
      salesChannels: [],
      priceModes: [],
      discountTypes: [],
    },

    supportsConfirm:
      true,

    supportsCancel:
      true,

    supportsDuplicate:
      true,

    supportsConvert:
      true,

    supportsDelete:
      true,

    supportsHistory:
      true,
  });

/*
|--------------------------------------------------------------------------
| REDUCER
|--------------------------------------------------------------------------
*/

export default
  quotationModule.reducer;

/*
|--------------------------------------------------------------------------
| ACTIONS
|--------------------------------------------------------------------------
*/

export const {
  setFilters:
    setQuotationFilters,

  setFilter:
    setQuotationFilter,

  setPage:
    setQuotationPage,

  setLimit:
    setQuotationLimit,

  resetFilters:
    resetQuotationFilters,

  setSelectedDocument:
    setSelectedQuotation,

  clearSelectedDocument:
    clearSelectedQuotation,

  clearHistory:
    clearQuotationHistory,

  clearErrors:
    clearQuotationErrors,

  clearOperation:
    clearQuotationOperation,

  clearLastCreatedDocument:
    clearLastCreatedQuotation,

  clearLastDuplicatedDocument:
    clearLastDuplicatedQuotation,

  clearLastConvertedDocument:
    clearLastConvertedDocument,

  resetState:
    resetQuotationState,
} =
  quotationModule.actions;

/*
|--------------------------------------------------------------------------
| THUNKS
|--------------------------------------------------------------------------
*/

export const {
  fetchDocuments:
    fetchQuotations,

  fetchSummary:
    fetchQuotationSummary,

  fetchCreateData:
    fetchQuotationCreateData,

  fetchDropdowns:
    fetchQuotationDropdowns,

  fetchDocumentById:
    fetchQuotationById,

  createDocument:
    createQuotation,

  updateDocument:
    updateQuotation,

  confirmDocument:
    confirmQuotation,

  cancelDocument:
    cancelQuotation,

  duplicateDocument:
    duplicateQuotation,

  convertDocument:
    convertQuotation,

  deleteDocument:
    deleteQuotation,

  fetchDocumentHistory:
    fetchQuotationHistory,
} =
  quotationModule.thunks;

/*
|--------------------------------------------------------------------------
| SELECTORS
|--------------------------------------------------------------------------
*/

export const {
  selectModule:
    quotationSelector,

  selectDocuments:
    quotationListSelector,

  selectSelectedDocument:
    selectedQuotationSelector,

  selectSummary:
    quotationSummarySelector,

  selectFilters:
    quotationFiltersSelector,

  selectPagination:
    quotationPaginationSelector,

  selectCreateData:
    quotationCreateDataSelector,

  selectDropdowns:
    quotationDropdownsSelector,

  selectHistory:
    quotationHistorySelector,

  selectLoading:
    quotationLoadingSelector,

  selectOperation:
    quotationOperationSelector,
} =
  quotationModule.selectors;